const STORAGE_KEY = "capture_cookie_consent_v1";

export function applyOptOut() {
  if (typeof window === "undefined") return;
  window._learnq = new Proxy([] as unknown[][], {
    get: (target, prop) =>
      prop === "push" ? () => {} : (target as never)[prop],
  });
  if (window.gtag) {
    window.gtag("consent", "update", {
      analytics_storage: "denied",
      ad_storage: "denied",
    });
  }
}

// Mirrors the choice into a cookie so the server can honor it for
// server-side conversion APIs (Reddit CAPI).
function syncConsentCookie(value: string | null) {
  if (value === "opted-out") {
    document.cookie = `capture_consent=opted-out; path=/; max-age=${60 * 60 * 24 * 365}; SameSite=Lax`;
  } else {
    document.cookie = "capture_consent=; path=/; max-age=0; SameSite=Lax";
  }
}

export function applySavedConsent() {
  if (typeof window === "undefined") return;
  const saved = localStorage.getItem(STORAGE_KEY);
  syncConsentCookie(saved);
  if (saved === "opted-out") applyOptOut();
}

export function getConsentStatus(): string | null {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(STORAGE_KEY);
}

export function saveConsent(value: "accepted" | "opted-out") {
  if (typeof window === "undefined") return;
  localStorage.setItem(STORAGE_KEY, value);
  syncConsentCookie(value);
  if (value === "opted-out") {
    // Stop sending the Reddit click ID with later requests.
    document.cookie = "_rdt_cid=; path=/; max-age=0; SameSite=Lax";
    // ChatGPT Ads pixel: stop measurement for the rest of the visit.
    try { (window as { oaiq?: (...args: unknown[]) => void }).oaiq?.("consent", false); } catch { /* non-fatal */ }
    // Microsoft Advertising (UET): deny ad storage for the rest of the visit.
    try { (window as { uetq?: { push: (...args: unknown[]) => unknown } }).uetq?.push("consent", "update", { ad_storage: "denied" }); } catch { /* non-fatal */ }
  }
}
